import React, { Fragment} from "react";
import logomin_img from"./images/logomin.svg";
import {getMessage} from "./util";

const version = require('../package.json');

const Footer =(props)=> {

        return (
            <Fragment>
                <div className="row justify-content-center EvColorBlue align-items-center">

                    <div className="col-md-6 col-8 mt-4 mr-4 mb-4 text-white text-center font-weight-bold">
                        <p>{getMessage("correo", props.messages)}: {getMessage("correo_soporte", props.messages)}</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 text-right">
                        <small>© EVoting {new Date().getFullYear()}, v. {version.version}</small>
                        </div>
                </div>
            </Fragment>

        );
    
}


export default Footer;